import { Injectable } from '@angular/core';
import { isJson } from '@intellio/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  get(key: string) {
    const storageItem = sessionStorage.getItem(key);
    if (isJson(storageItem)) {
      return JSON.parse(storageItem);
    }
    return storageItem;
  }

  set(key: string, value: unknown) {
    if (typeof value === 'string') {
      sessionStorage.setItem(key, value);
    } else {
      try {
        const stringVal = JSON.stringify(value);
        sessionStorage.setItem(key, stringVal);
      } catch (error) {
        sessionStorage.setItem(key, error);
      }
    }
    return this.get(key);
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  doesExist(key: string) {
    if (this.get(key)) {
      return true;
    }
    return false;
  }
}
